// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3df7U","blockButton":"BiODU","addWishlist":"_2D24O","form":"_2iiwq","headerForm":"_1lA9M","dot":"m6Oak","text":"_1ggcc","formInput":"_1K876"};